// @flow

export function safelyPlayMedia(element: HTMLMediaElement): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      const playPromise = element.play()
      if (playPromise) {
        playPromise.then(resolve).catch(reject)
      } else {
        resolve()
      }
    } catch (err) {
      reject(err)
    }
  })
}
